// src/components/strumenti/VolumeForme.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"9px 10px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

const FORME = {
  parallelepipedo: { label:"Parallelepipedo (scavo, vano, ecc.)", campi:["lunghezza","larghezza","altezza"] },
  cilindro: { label:"Cilindro", campi:["raggio","altezza"] },
  cono: { label:"Cono", campi:["raggio","altezza"] },
};
const LABEL_CAMPO = { lunghezza:"Lunghezza (m)", larghezza:"Larghezza (m)", altezza:"Altezza (m)", raggio:"Raggio (m)" };

export default function VolumeForme() {
  const [forma, setForma] = useState("parallelepipedo");
  const [valori, setValori] = useState({});

  const v = k => leggiNumero(valori[k])||0;
  const set = (k,val) => setValori(o=>({...o,[k]:val}));

  let volume=null;
  if (forma==="parallelepipedo") {
    const l=v("lunghezza"), la=v("larghezza"), h=v("altezza");
    if (l>0&&la>0&&h>0) volume=l*la*h;
  } else if (forma==="cilindro") {
    const r=v("raggio"), h=v("altezza");
    if (r>0&&h>0) volume=Math.PI*r*r*h;
  } else if (forma==="cono") {
    const r=v("raggio"), h=v("altezza");
    if (r>0&&h>0) volume=(Math.PI*r*r*h)/3;
  }

  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Forma</label>
        <select value={forma} onChange={e=>{setForma(e.target.value);setValori({});}} style={inp}>
          {Object.entries(FORME).map(([k,f]) => <option key={k} value={k}>{f.label}</option>)}
        </select>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:`repeat(${FORME[forma].campi.length},1fr)`, gap:10, marginBottom:16 }}>
        {FORME[forma].campi.map(c => (
          <div key={c}>
            <label style={lbl}>{LABEL_CAMPO[c]}</label>
            <input value={valori[c]||""} onChange={e=>set(c,e.target.value)} style={inp} placeholder="Es. 2"/>
          </div>
        ))}
      </div>

      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Volume</div>
        <div style={{ fontSize:24, fontWeight:800, color:"#15803d" }}>
          {volume!==null ? volume.toLocaleString("it-IT",{maximumFractionDigits:3}) : "—"}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>m³</span>
        </div>
        {volume!==null && <div style={{ fontSize:11, color:"#6b7280", marginTop:4 }}>≈ {(volume*1000).toLocaleString("it-IT",{maximumFractionDigits:0})} litri</div>}
      </div>

      <button onClick={()=>setValori({})}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
